import {
  SEND_LEADSQUARED_INFO,
  SEND_HUBSPOT_INFO,
  GET_LEADSQUARED_INFO,
  GET_HUBSPOT_INFO,
  SAVE_LEADSQUARED_INFO,
  SAVE_HUBSPOT_INFO,
  SEND_LSQ_WHATSAPP_CONNECTOR,
  SAVE_LSQ_WHATSAPP_CONNECTOR,
  GET_LSQ_WHATSAPP_CONNECTOR,
  GET_ZOHOCRM_INFO,
  SAVE_ZOHOCRM_INFO,
  SAVE_GOOGLESHEETS_INFO,
  GET_GOOGLESHEETS_INFO,
  GET_ZOHO_DESK_INFO,
  SAVE_ZOHO_DESK_INFO
} from "../constants/MarketPlace";

export const sendLeadSquaredInfo = (data) => {
  return {
    type: SEND_LEADSQUARED_INFO,
    payload: data,
  };
};

export const getLeadSquaredInfo = () => {
  return {
    type: GET_LEADSQUARED_INFO,
  };
};

export const saveLeadSquaredInfo = (data) => {
  return {
    type: SAVE_LEADSQUARED_INFO,
    payload: data,
  };
};

export const sendHubspotInfo = (data) => {
  return {
    type: SEND_HUBSPOT_INFO,
    payload: data,
  };
};

export const getHubspotInfo = () => {
  return {
    type: GET_HUBSPOT_INFO,
  };
};

export const saveHubspotInfo = (data) => {
  return {
    type: SAVE_HUBSPOT_INFO,
    payload: data,
  };
};

// export const sendLSQWhatsappConnector = (data) => {
//   return {
//     type: SEND_LSQ_WHATSAPP_CONNECTOR,
//     payload: data,
//   };
// };

export const getLSQWhatsappConnector = () => {
  return {
    type: GET_LSQ_WHATSAPP_CONNECTOR,
  };
};

export const saveLSQWhatsappConnector = (data) => {
  return {
    type: SAVE_LSQ_WHATSAPP_CONNECTOR,
    payload: data,
  };
};


export const getZohoCRMInfo = () => {
  return {
    type: GET_ZOHOCRM_INFO,
  };
};

export const saveZohoCRMInfo = (data) => {
  return {
    type: SAVE_ZOHOCRM_INFO,
    payload: data,
  };
};


export const getGoogleSheetsInfo = () => {
  return {
    type: GET_GOOGLESHEETS_INFO,
  };
};

export const saveGoogleSheetsInfo = (data) => {
  return {
    type: SAVE_GOOGLESHEETS_INFO,
    payload: data,
  };
};

export const getZohoDeskInfo = () => {
  return {
    type: GET_ZOHO_DESK_INFO,
  };
};

export const saveZohoDeskInfo = (data) => {
  return {
    type: SAVE_ZOHO_DESK_INFO,
    payload: data,
  };
};
